import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecentlyViewed = ({ products, onProductClick, onClearHistory }) => {
  if (!products || products?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-wellness p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Clock" size={20} className="text-muted-foreground" />
          <h3 className="font-heading font-semibold text-foreground">Recently Viewed</h3>
        </div>
        <div className="text-center py-8">
          <Icon name="Eye" size={48} className="text-muted mx-auto mb-3" />
          <p className="text-muted-foreground">No recently viewed products</p>
          <p className="text-sm text-muted-foreground mt-1">
            Products you view will appear here for quick access
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-wellness p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={20} className="text-primary" />
          <h3 className="font-heading font-semibold text-foreground">Recently Viewed</h3>
          <span className="bg-muted text-muted-foreground text-xs px-2 py-1 rounded-full">
            {products?.length}
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearHistory}
          iconName="Trash2"
          iconPosition="left"
        >
          Clear
        </Button>
      </div>
      <div className="space-y-3">
        {products?.slice(0, 5)?.map((product) => (
          <div
            key={product?.id}
            onClick={() => onProductClick?.(product)}
            className="flex items-center space-x-3 p-3 rounded-lg hover:bg-muted transition-wellness cursor-pointer group"
          >
            <div className="relative flex-shrink-0">
              <Image
                src={product?.image}
                alt={product?.name}
                className="w-12 h-12 object-cover rounded-lg"
              />
              {product?.isNew && (
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-success rounded-full"></div>
              )}
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="font-medium text-foreground text-sm truncate group-hover:text-primary transition-wellness">
                {product?.name}
              </h4>
              <div className="flex items-center space-x-2 mt-1">
                <span className="text-xs text-primary bg-primary/10 px-2 py-0.5 rounded-full">
                  {product?.category}
                </span>
                <span className="text-xs text-muted-foreground">
                  {product?.centerName}
                </span>
              </div>
              <div className="flex items-center space-x-2 mt-1">
                <div className="flex items-center space-x-1">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon
                      key={i}
                      name="Star"
                      size={10}
                      className={i < Math.floor(product?.rating) ? 'text-accent fill-current' : 'text-muted'}
                    />
                  ))}
                </div>
                <span className="text-xs text-muted-foreground">
                  {product?.rating}
                </span>
              </div>
            </div>

            <div className="flex flex-col items-end space-y-1">
              <span className="font-semibold text-foreground">
                ${product?.price}
              </span>
              <span className="text-xs text-muted-foreground">
                {product?.viewedAt}
              </span>
            </div>

            <Icon
              name="ChevronRight"
              size={16}
              className="text-muted-foreground group-hover:text-primary transition-wellness"
            />
          </div>
        ))}
      </div>
      {products?.length > 5 && (
        <div className="mt-4 pt-4 border-t border-border">
          <Button variant="outline" size="sm" className="w-full">
            View All {products?.length} Items
          </Button>
        </div>
      )}
    </div>
  );
};

export default RecentlyViewed;